import React from 'react';
import { useIntl } from 'react-intl';
import {
  ApiFilterOperation,
  Evidence,
  TableCells,
  TableColumn,
} from '@eas/common-web';
import { Decision } from '@models';
import { DecisionState } from '@enums';
import { useColumns } from '../decision/decision-columns';
import { useDecisions } from '../decision/decisions';

export function AccessibleDecisions() {
  const intl = useIntl();
  const decisionColumns = useColumns();

  const columns: TableColumn<Decision>[] = [
    ...decisionColumns,
    {
      datakey: 'firstMadeAccessibleDate',
      name: intl.formatMessage({
        id: 'ES__DECISIONS__TABLE__COLUMN__FIRST_MADE_ACCESSIBLE_DATE',
        defaultMessage: 'Datum prvního zpřístupnění',
      }),
      width: 200,
      CellComponent: TableCells.DateCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'lastMadeAccessibleDate',
      name: intl.formatMessage({
        id: 'ES__DECISIONS__TABLE__COLUMN__LAST_MADE_ACCESSIBLE_DATE',
        defaultMessage: 'Datum posledního zveřejnění',
      }),
      width: 200,
      CellComponent: TableCells.DateCell,
      sortable: true,
      filterable: true,
    },
  ];

  const defaultPreFilters = [
    {
      field: 'state.id',
      operation: ApiFilterOperation.EQ,
      value: DecisionState.ACCESSIBLE,
    },
  ];

  const { evidenceBag } = useDecisions({
    evidenceProps: {
      version: 24,
      tableProps: {
        columns,
        defaultPreFilters,
        tableName: intl.formatMessage({
          id: 'ES__ACCESSIBLE_DECISIONS__TABLE__TITLE',
          defaultMessage: 'Rozhodnutí - zpřístupněná',
        }),
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
